import * as CONST from "./actionTypes";

// =================BASIC-SETTING-DETAILS =================== //

export const basicSettingDetails = (payload, callBack) => {
  return {
    type: CONST.BASIC_SETTING_DETAILS,
    payload: payload,
    callBack,
  };
};

export const basicSettingDetails_Success = (payload) => ({
  type: CONST.BASIC_SETTING_DETAILS_SUCCESS,
  payload,
});

export const basicSettingDetails_Fail = (payload) => ({
  type: CONST.BASIC_SETTING_DETAILS_FAIL,
  payload,
});

// =================GET-BASIC-DETAILS =================== //

export const getBasicDetails = (payload, callBack) => {
  return {
    type: CONST.GET_BASIC_DETAILS,
    payload: payload,
    callBack,
  };
};

export const getBasicDetails_Success = (payload) => ({
  type: CONST.GET_BASIC_DETAILS_SUCCESS,
  payload,
});

export const getBasicDetails_Fail = (payload) => ({
  type: CONST.GET_BASIC_DETAILS_FAIL,
  payload,
});

// =================change pass otp =================== //

export const changePassOtp = (payload, callBack) => {
  return {
    type: CONST.CHANGE_PASS_OTP,
    payload: payload,
    callBack,
  };
};

export const changePassOtp_Success = (payload) => ({
  type: CONST.CHANGE_PASS_OTP_SUCCESS,
  payload,
});

export const changePassOtp_Fail = (payload) => ({
  type: CONST.CHANGE_PASS_OTP_FAIL,
  payload,
});

// =================change pass otp verify =================== //

export const changePassOtpVerify = (payload, callBack) => {
  return {
    type: CONST.CHANGE_PASS_OTP_VERIFY,
    payload: payload,
    callBack,
  };
};

export const changePassOtpVerify_Success = (payload) => ({
  type: CONST.CHANGE_PASS_OTP_VERIFY_SUCCESS,
  payload,
});

export const changePassOtpVerify_Fail = (payload) => ({
  type: CONST.CHANGE_PASS_OTP_VERIFY_FAIL,
  payload,
});

// =================change pass admin =================== //

export const changePassAdmin = (payload, callBack) => {
  return {
    type: CONST.CHANGE_PASS_ADMIN,
    payload: payload,
    callBack,
  };
};

export const changePassAdmin_Success = (payload) => ({
  type: CONST.CHANGE_PASS_ADMIN_SUCCESS,
  payload,
});

export const changePassAdmin_Fail = (payload) => ({
  type: CONST.CHANGE_PASS_ADMIN_FAIL,
  payload,
});
